import { Slice } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SliceIcon = createLucideIcon(Slice);
